
import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardFooter, CardHeader } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { blogPosts } from '@/data/blogPosts';

const BlogPostList = () => {
  return (
    <div className="space-y-6">
      {blogPosts.map((post) => (
        <Card key={post.slug} className="overflow-hidden">
          <CardHeader className="p-0">
            <div className="h-48 bg-gray-200">
              {post.image ? (
                <img 
                  src={post.image} 
                  alt={post.title} 
                  className="h-full w-full object-cover"
                />
              ) : (
                <div className="h-full w-full flex items-center justify-center bg-blue-100 text-blue-500">
                  <span className="text-lg">allunitcalculators.com</span>
                </div>
              )}
            </div>
          </CardHeader>
          <CardContent className="pt-6">
            <div className="mb-2 flex items-center">
              <span className="text-xs text-gray-500">{post.date}</span>
              {post.category && (
                <Link 
                  to={`/blog/category/${post.category.toLowerCase().replace(/\s+/g, '-')}`}
                  className="ml-2 bg-blue-100 text-blue-700 text-xs px-2 py-1 rounded-full"
                >
                  {post.category}
                </Link>
              )}
            </div>
            <h2 className="text-xl font-bold mb-2">
              <Link to={`/blog/${post.slug}`} className="hover:text-blue-600 transition-colors">
                {post.title}
              </Link>
            </h2>
            <p className="text-gray-600 line-clamp-3">{post.excerpt}</p>
          </CardContent>
          <CardFooter>
            <Button variant="ghost" asChild>
              <Link to={`/blog/${post.slug}`}>Read More</Link>
            </Button>
          </CardFooter>
        </Card>
      ))}
    </div>
  );
};

export default BlogPostList;
